var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanningReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7292 30.9092H46.8298",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6125 31.6095L15.2964 34.833L21.743 27.2256",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7292 49.5684H46.8298",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6125 50.0292L15.2964 53.2527L21.743 45.8848",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7292 68.209H46.8298",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6125 68.6698L15.2964 71.8933L21.743 64.5254",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9075 83.1843H53.9711C55.7393 83.1843 57.1944 81.7475 57.1944 79.9608V16.6336C57.1944 14.8653 55.7393 13.4102 53.9711 13.4102H49.2374",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06753 13.4102H4.26017C2.45511 13.4102 1 14.8469 1 16.6152V73.2744",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1105 11.5682C30.6364 11.5682 31.8734 10.2818 31.8734 8.69477C31.8734 7.10779 30.6364 5.82129 29.1105 5.82129C27.5846 5.82129 26.3477 7.10779 26.3477 8.69477C26.3477 10.2818 27.5846 11.5682 29.1105 11.5682Z",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9392 8.7316H37.0083C37.0083 4.32927 33.4719 0.755859 29.1065 0.755859C24.7412 0.755859 21.2048 4.32927 21.2048 8.7316H15.2923C13.7819 8.7316 12.5479 9.96572 12.5479 11.4946V15.7127C12.5479 17.2415 13.7819 18.4941 15.2923 18.4941H42.9576C44.468 18.4941 45.7021 17.2415 45.7021 15.7127V11.4946C45.7021 9.96572 44.4864 8.7316 42.9576 8.7316H42.9392Z",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0245 17.334H72.5241C74.9923 17.334 77 18.9733 77 20.9995V68.9646C77 69.4435 76.9079 69.9224 76.7053 70.3645L71.2901 82.982C71.1059 83.4241 70.4612 83.4241 70.277 82.982L64.8618 70.3645C64.6592 69.9224 64.5671 69.4251 64.5671 68.9646V20.9995C64.5671 18.9733 66.5564 17.334 69.0429 17.334H69.0245Z",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5459 76.498H73.9926",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5671 24.7012H77",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5671 28.3857H77",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9949 68.209C76.3871 69.0379 75.1714 69.5905 73.79 69.5905C72.7954 69.5905 71.8744 69.2958 71.2298 68.8168C71.064 68.6879 70.8982 68.559 70.7693 68.43",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7713 68.43C70.6424 68.559 70.495 68.7063 70.3108 68.8168C69.6661 69.2958 68.7452 69.5905 67.7506 69.5905C66.3691 69.5905 65.1719 69.0379 64.5457 68.209",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7693 68.4487V28.3857",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningReportIcon);
export default __webpack_public_path__ + "static/media/planning-report-icon.a819a355.svg";
export { ForwardRef as ReactComponent };